import { App } from "vue"
import { BaseInput, Checkbox, Select } from "@xy-planning-network/trees"

/**
 * declare the global component types
 * should provide code completiong support in your editor - milage may vary
 * provides proper type checking on the components declared props
 */
declare module "@vue/runtime-core" {
  interface GlobalComponents {
    Checkbox: typeof Checkbox
    Select: typeof Select
  }
}

/**
 * export a plugin object with an install method
 */
export default {
  install(app: App) {
    app.component("BaseInput", BaseInput)
    app.component("Checkbox", Checkbox)
    // eslint-disable-next-line vue/no-reserved-component-names
    app.component("Select", Select)
  },
}
